<script lang="ts" setup>
const { collection } = defineProps<{ collection: CollectionConfig }>()

const buttons = computed(() => {
  return [
    {
      title: `Click Here To View All`,
      expand: { page: { slug: `${collection.pub?.collectionRoute}` } },
    },
  ]
})
</script>

<template>
  <div class="rounded-2xl relative flex flex-wrap overflow-clip h-full bg-p-900 items-center justify-center px-6 md:px-12 py-12 text-white ">
    <div class="flex flex-col gap-6 items-center z-10">
      <p class="text-3xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-semibold uppercase font-display text-yellow text-center text-balance !leading-[0.8]">
        View All {{ collection.collection }}
      </p>
      <PageButtons
        :buttons="buttons"
        size="xl"
      />
    </div>
    <div class="absolute left-[-10%] bottom-5 w-1/2 aspect-square bg-p-800 rounded-full" />
    <div class="absolute right-[-20%] bottom-[40%] w-1/2 aspect-square bg-p-700 rounded-full" />
  </div>
</template>
